import { ref, onUnmounted, type Ref } from 'vue';

export interface UseCountdownReturn {
  remaining: Ref<number>;
  isRunning: Ref<boolean>;
  /** 启动倒计时；可传入自定义秒数（如后端返回的剩余冷却秒数），缺省用 defaultSeconds */
  start: (customSeconds?: number) => void;
  reset: () => void;
}

export function useCountdown(defaultSeconds = 60): UseCountdownReturn {
  const remaining = ref(0);
  const isRunning = ref(false);
  let timer: ReturnType<typeof setInterval> | null = null;

  function clear() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function start(customSeconds?: number) {
    if (isRunning.value) return;
    clear();
    remaining.value = customSeconds ?? defaultSeconds;
    isRunning.value = true;
    timer = setInterval(() => {
      remaining.value -= 1;
      if (remaining.value <= 0) {
        clear();
        isRunning.value = false;
      }
    }, 1000);
  }

  function reset() {
    clear();
    remaining.value = 0;
    isRunning.value = false;
  }

  onUnmounted(() => {
    clear();
  });

  return {
    remaining,
    isRunning,
    start,
    reset,
  };
}
